// extracted by mini-css-extract-plugin
export default {"wrapper":"Go-z","response":"Ho-z","error":"Io-z","disabled":"Jo-z","buttons":"Ko-z","feedbackQuestionSection":"Lo-z","yesNoWrapper":"Mo-z"};